import Main from './_main';
import Home from './_home';
import Business from './_business';
import Engineer from './_engineer';
import Internship from './_internship';

new Main();
new Home();
new Business();
new Engineer();
new Internship();
